<template>
    <div class="elButton">
        <slot/>
    </div>
</template>